module.exports = __webpack_public_path__ + "img/meal-management-ja.f181ac59.png";